// Polyfills for Node.js modules in the browser
import { Buffer } from "buffer";
import process from "process/browser";

// Make Buffer and process available globally
(window as any).global = window;
(window as any).Buffer = Buffer;
(window as any).process = process;

// Additional polyfills if needed
export {};
